import { render } from "./ManageGuestGroups.vue?vue&type=template&id=c5bc2956&scoped=true"
import script from "./ManageGuestGroups.vue?vue&type=script&lang=js"
export * from "./ManageGuestGroups.vue?vue&type=script&lang=js"

import "./ManageGuestGroups.vue?vue&type=style&index=0&id=c5bc2956&scoped=true&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\BrikTokApi\\BrikTokAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5bc2956"]])

export default __exports__